import React from 'react'
import PickColumn from './PickColumn/PickColumn'
import ActiveOSPList from './ActiveSellerList/ActiveOSPList'

export default function View_Settings({ message }) {

    return (
        <div>
            <div className='border-2 border-gray-200 rounded-xl'>
                <div className='border-b-2 border-gray-200 p-5 flex items-center justify-between'>
                    <div className='font-bold text-gray-600 text-xl'>
                        View Settings
                    </div>
                </div>

                <div className="py-5">
                    <div className="flex gap-6 justify-center">
                        <div className="flex items-center gap-3">
                            <h1 className="text-oceanBlue">
                                No.of Column Shown in the Table :{" "}</h1>
                            <PickColumn />
                        </div>

                        <div className="flex items-center gap-3">
                            <h1 className="text-oceanBlue">
                                No.of Rows Shown in the Table :{" "}</h1>
                            <select name="" id="">
                                <option value="20">20</option>
                                <option value="100">100</option>
                                <option value="500">500</option>
                                <option value="2500">2500</option>
                                <option value="5000">5000</option>
                            </select>
                        </div>
                    </div>
                </div>

                {/* <div className="flex items-center justify-end px-10 pb-5">
                    <button type="button" className="text-gray-500 bg-gray-200 hover:text-gray-700 px-3 py-1 rounded-md text-xl">set as Default</button>
                </div> */}
            </div>

            <div className='mt-10'>
                <ActiveOSPList message={message} />
            </div>
        </div>
    )
}
